<!--
 * @Author: zb
 * @LastEditors: l_hc
 * @Date: 2019-08-08 19:37:57
 * @LastEditTime: 2019-10-18 18:30:29
 * @Version: 1.0
 * @Description: 石化运输中货源信息的展示页面
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks: 备注
 -->

<template>
  <div class="source-news">
    <div class="main-wrap">
      <select-condition ref="selectCondition" :config="config" @refresh="refresh">
        <template v-slot:transportDate="{ data, scope }">
          <div class="transport-data">
            <el-date-picker :ref="data.key[0]" v-model="scope[data.key[0]]" :editable="false" :picker-options="data.transportDateStartpickerOptions"
              :value-format="data.dateValueFormat" :format="data.dateValueFormat" type="date" align="right" />
            <div class="des">
              <span>-</span>
            </div>
            <el-date-picker :ref="data.key[1]" v-model="scope[data.key[1]]" :editable="false" :picker-options="data.transportDateEndpickerOptions"
              :value-format="data.dateValueFormat" :format="data.dateValueFormat" type="date" align="right" />
          </div>
        </template>
        <template v-slot:deliveryDate="{ data, scope }">
          <div class="transport-data">
            <el-date-picker :ref="data.key[0]" v-model="scope[data.key[0]]" :editable="false" :picker-options="data.transportDateStartpickerOptions"
              :value-format="data.dateValueFormat" :format="data.dateValueFormat" type="date" align="right" />
            <div class="des">
              <span>-</span>
            </div>
            <el-date-picker :ref="data.key[1]" v-model="scope[data.key[1]]" :editable="false" :picker-options="data.transportDateEndpickerOptions"
              :value-format="data.dateValueFormat" :format="data.dateValueFormat" type="date" align="right" />
          </div>
        </template>
        <template v-slot:capacity="{data, scope}">
          <el-radio-group v-model="scope[data.key[0]]" @change="weightChange(scope,data,scope[data.key[0]])">
            <el-radio-button v-for="(i,index) of weight" :key="index" :label="i.value">{{ i.label }}</el-radio-button>
          </el-radio-group>

          <el-input v-model="scope[data.key[1]]" />
          <div class="des">
            <span>——</span>
          </div>
          <el-input v-model="scope[data.key[2]]" />
          <el-button class="el-button-ml" @click="changeCapacityWithCustom(scope)">确定</el-button>
        </template>
      </select-condition>
      <!--表格 -->
      <div v-loading="viewManager.loading" class="table-wrap">
        <goods-item :show-data="resultData" @refreshPage="refreshPage" @offer="quotation" @favorites="favorites" />
      </div>
    </div>
    <!-- 报价对话框  -->
    <offer ref="offer-dialog" @done="initData" />
  </div>
</template>

<script>
  import goodsItem from '@/views/personal/goods/components/goodsItems'
  import {
    Page
  } from '@/utils/commonDataModel'
  import {
    getwebMapList
  } from '@/api/personal/find/goodsManager'
  import {
    conllection
  } from '@/api/cloud/storage-demand-info/storageDemandInfo'
  import offer from '@/views/personal/transport/offer'
  import mixinsFunction from '@/utils/mixinsFunction'
  import SelectCondition from './SelectCondition/SelectCondition'
  const shortcuts = [{
      text: '今天',
      onClick(picker) {
        picker.$emit('pick', new Date())
      }
    },
    {
      text: '昨天',
      onClick(picker) {
        const date = new Date()
        date.setTime(date.getTime() - 3600 * 1000 * 24)
        picker.$emit('pick', date)
      }
    },
    {
      text: '一周前',
      onClick(picker) {
        const date = new Date()
        date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
        picker.$emit('pick', date)
      }
    }
  ]

  const validateNumber = value => {
    if (value.length > 15) {
      throw Error('长度最大为15')
    } else {
      const reg = /^[+]{0,1}[1-9]{1}(\d*)$|^[+]{0,1}(\d+\.\d+)$/
      if (reg.test(value) === false) {
        throw Error('请输入正确内容(正数、包括小数)')
      }
    }
  }

  export default {
    name: 'SourceNews',
    components: {
      'goods-item': goodsItem,
      offer,
      SelectCondition
    },
    mixins: [mixinsFunction],
    data() {
      return {
        quickFlag: false,
        area: [],
        goodsType: [],
        weight: [],
        // 列表数据
        resultData: {},
        pagination: new Page(),
        param: {},
        isBtn: false,
        config: [{
            label: '起运地',
            key: 'startPlace',
            component: {
              type: 'cascader',
              data: () => this.area,
              showPath: true
            }
          },
          {
            label: '目的地',
            key: 'stopPlace',
            component: {
              type: 'cascader',
              data: () => this.area,
              showPath: true
            }
          },
          {
            label: '发货时间',
            key: ['startTransportDate', 'endTransportDate'],
            showLabel: function(item) {
              if (
                this.dataModal[item.key[0]] &&
                this.dataModal[item.key[0]].toString() !== '' &&
                this.dataModal[item.key[1]] &&
                this.dataModal[item.key[1]].toString() !== ''
              ) {
                return {
                  key: item.key.toString(),
                  text: `${item.label}:${this.dataModal[item.key[0]]} 至 ${
                  this.dataModal[item.key[1]]
                }`
                }
              }
            },
            dateValueFormat: 'yyyy-MM-dd',
            transportDateStartpickerOptions: {
              shortcuts: shortcuts,
              disabledDate: time => {
                if (this.$refs['selectCondition']) {
                  const beginDateVal = this.$refs['selectCondition'].$data
                    .dataModal.endTransportDate
                  if (beginDateVal) {
                    return time.getTime() > Date.parse(beginDateVal)
                  }
                }
              }
            },
            transportDateEndpickerOptions: {
              shortcuts: shortcuts,
              disabledDate: time => {
                if (this.$refs['selectCondition']) {
                  const beginDateVal = this.$refs['selectCondition'].$data
                    .dataModal.startTransportDate
                  if (beginDateVal) {
                    return time.getTime() < Date.parse(beginDateVal)
                  }
                }
              }
            },
            component: {
              slot: 'transportDate'
            }
          },
          {
            label: '送达时间',
            key: ['startmostLateDeliveryDate', 'endmostLateDeliveryDate'],
            showLabel: function(item) {
              if (
                this.dataModal[item.key[0]] &&
                this.dataModal[item.key[0]].toString() !== '' &&
                this.dataModal[item.key[1]] &&
                this.dataModal[item.key[1]].toString() !== ''
              ) {
                return {
                  key: item.key.toString(),
                  text: `${item.label}:${this.dataModal[item.key[0]]} 至 ${
                  this.dataModal[item.key[1]]
                }`
                }
              }
            },
            dateValueFormat: 'yyyy-MM-dd',
            transportDateStartpickerOptions: {
              shortcuts: shortcuts,
              disabledDate: time => {
                if (this.$refs['selectCondition']) {
                  // 如果发货时间的最大值存在
                  if (
                    this.$refs['selectCondition'].$data.dataModal.endTransportDate
                  ) {
                    const beginDateVal = this.$refs['selectCondition'].$data
                      .dataModal.endTransportDate
                    const endDateVal = this.$refs['selectCondition'].$data
                      .dataModal.endmostLateDeliveryDate
                    if (beginDateVal) {
                      return (
                        time.getTime() > Date.parse(endDateVal) ||
                        time.getTime() < Date.parse(beginDateVal)
                      )
                    }
                  } else {
                    return true
                  }
                }
              }
            },
            transportDateEndpickerOptions: {
              shortcuts: shortcuts,
              disabledDate: time => {
                if (this.$refs['selectCondition']) {
                  const beginDateVal = this.$refs['selectCondition'].$data
                    .dataModal.endTransportDate
                  const endDateVal = this.$refs['selectCondition'].$data.dataModal
                    .startmostLateDeliveryDate
                  if (beginDateVal) {
                    return (
                      time.getTime() < Date.parse(endDateVal) ||
                      time.getTime() < Date.parse(beginDateVal)
                    )
                  } else {
                    return true
                  }
                }
              }
            },
            component: {
              slot: 'deliveryDate'
            }
          },
          {
            label: '重量',
            key: ['capacityText', 'capacityTextStart', 'capacityTextEnd'],
            showLabel: function(item) {
              if (
                this.dataModal[item.key[0]] &&
                this.dataModal[item.key[0]] !== ''
              ) {
                const suit = item.component.data().filter(i => {
                  return i.value == this.dataModal[item.key[0]]
                })
                if (suit && suit.length > 0) {
                  return {
                    key: item.key,
                    text: `${item.label}:${suit[0].label}`
                  }
                } else {
                  return {
                    key: item.key,
                    text: `${item.label}:${this.dataModal[item.key[0]]}吨`
                  }
                }
              }
            },
            class: {
              'capacity-content': true
            },
            component: {
              type: 'cascader',
              slot: 'capacity',
              data: () => this.weight
            }
          },
          {
            label: '货源类型',
            key: 'goodsType',
            default: [],
            showLabel: function(item) {
              // console.log(334, item)
              if (this.dataModal[item.key] && this.dataModal[item.key] !== '') {
                const suit = item.component.data().filter(i => {
                  return this.dataModal[item.key].indexOf(i.value) !== -1
                })
                if (suit && suit.length > 0) {
                  return {
                    key: item.key,
                    text: `${item.label}:${suit.map(i => i.label).join('/')}`
                  }
                }
              }
            },
            component: {
              type: 'checkbox-group',
              data: () => this.goodsType
            }
          }
        ]
      }
    },
    watch: {
      // 监测路由变化
      $route: 'getQuick'
    },
    async created() {
      // console.log(373, this.$route.params.goodsForm)
      await Promise.all([
        this.getArea(),
        this.getGoodsType(),
        this.getWeight()
      ]).then(data => {
        [this.area, this.goodsType, this.weight] = data
      })
      // 判断是否有来自首页的快速查询,如果有,则不执行页面初始化的查询,执行快速查询
      if (JSON.stringify(this.$route.params)) {
        console.log("123")
        this.getQuick()
      }
    },
    methods: {
      refresh(data) {
        this.onSubmit(data)
      },
      getQuick() {
        console.log("getQuick");
        console.log(380, this.weight)
        // 判断是否有来自首页的快速查询,如果有,则不执行页面初始化的查询,执行快速查询
        if (this.$route.params.goodsForm) {
          this.quickFlag = true
          if (this.$refs['selectCondition']) {
            this.$refs[
              'selectCondition'
            ].$data.dataModal.startPlace = this.$route.params.goodsForm.startArea
            this.$refs[
              'selectCondition'
            ].$data.dataModal.stopPlace = this.$route.params.goodsForm.stopArea
            if (
              this.$route.params.goodsForm.capacity &&
              this.$route.params.goodsForm.capacity !== ''
            ) {
              this.$refs[
                'selectCondition'
              ].$data.dataModal.capacityText = JSON.parse(
                this.$route.params.goodsForm.capacity
              ).value
            }
            if (
              this.$route.params.goodsForm.type &&
              this.$route.params.goodsForm.type.length !== 0
            ) {
              this.$refs[
                'selectCondition'
              ].$data.dataModal.goodsType = JSON.parse(
                JSON.stringify(this.$route.params.goodsForm.type)
              ).map(item => JSON.parse(item).value)
            }
          }
        } else {
          this.initData()
        }
      },
      loadTableData(params) {
        this.viewManager.loading = true
        getwebMapList(this.pagination, params)
          .then(data => {
            data.result.rows = data.result.rows.map(item => {
              item.hidden = true
              return item
            })
            this.resultData = data.result
          })
          .catch(error => {
            console.error(error)
          })
          .finally(() => {
            this.viewManager.loading = false
          })
      },
      // 报价
      quotation(item) {
        this.$refs['offer-dialog'].open(item)
      },
      // 页面初始化 获取初始数据
      initData() {
        this.loadTableData()
      },
      // 收藏
      favorites(item) {
        // 请求未完成时重复点击
        if (item.collectionSubmit) {
          return false
        }
        item.collectionSubmit = true
        const favoritesFlag = item.favoritesFlag === '1' ? '2' : '1'
        // 发起收藏?取消收藏的请求
        conllection({
            id: item.collectionId,
            moduleId: item.id,
            moduleType: '1',
            collectionStatus: favoritesFlag
          })
          .then(data => {
            item.favoritesFlag = favoritesFlag
            item.collectionId = data.result.id
            this.$message({
              message: item.favoritesFlag == '1' ? '收藏成功' : '取消收藏成功',
              type: item.favoritesFlag == '1' ? 'success' : 'warning'
            })
            item.collectionSubmit = false
          })
          .catch(error => {
            console.error(error)
            item.collectionSubmit = false
          })
      },

      // 修改分页触发表单提交
      refreshPage(data) {
        this.pagination.pageSize = data.pageSize
        this.pagination.pageNo = data.pageNo
        this.loadTableData()
      },
      // 修改查询条件后触发查询
      onSubmit(data) {

        console.log(425, data)
        // 将查询条件绑定到页面的参数属性值上
        if (
          Object.prototype.toString.call(data.startPlace).indexOf('Array') !==
          -1 &&
          data.startPlace.length > 0
        ) {
          this.param.startPlace = data.startPlace.join('#')
        } else {
          this.param.startPlace = ''
        }
        if (
          Object.prototype.toString.call(data.stopPlace).indexOf('Array') !==
          -1 &&
          data.stopPlace.length > 0
        ) {
          this.param.stopPlace = data.stopPlace.join('#')
        } else {
          this.param.stopPlace = ''
        }
        this.param.minStartTransportDate = data.startTransportDate
        this.param.maxStartTransportDate = data.endTransportDate
        this.param.minMostLateDeliveryDate = data.startmostLateDeliveryDate
        this.param.maxMostLateDeliveryDate = data.endmostLateDeliveryDate
        console.log(data)

        if (data.capacityTextStart && data.capacityTextEnd) {
          // this.param.minWeight = data.capacityTextStart
          // this.param.maxWeight = data.capacityTextEnd
          this.param.weightValue = data.capacityTextStart + ',' + data.capacityTextEnd
        } else {
          this.param.weightValue = data.capacityText.replace("-",",")
        }
         // this.param.weightValue.split("-",",")
            console.log("isBtn"+this.isBtn+"--length:"+this.param.weightValue)

        if (!this.isBtn&&this.param.weightValue.length>0) {
          console.log("isBtn："+this.isBtn)
          return;
        }
        if(data.capacityTextStart.length>0&&!this.isBtn){
          return;
          }

    this.isBtn=false
        this.param.goodsType = data.goodsType.toString()
        this.loadTableData(this.param)
      },
      // 修改重量
      changeCapacityWithCustom(scope, data) {
        scope.capacityText = ''
        if (scope.capacityTextStart === '') {
          // scope.capacityTextStart = '1'
          this.$message({
            offset: 100,
            message: '请输入重量范围!',
            type: 'warning'
          })
          return
        } else if (scope.capacityTextStart !== '0') {
          try {
            validateNumber(scope.capacityTextStart)
          } catch (e) {
            this.$message({
              showClose: true,
              message: e.message,
              type: 'error'
            })
            scope.capacityTextStart = '1'
            scope.capacityTextEnd = '1'
            return
          }
        }
        if (scope.capacityTextEnd === '') {
          // scope.capacityTextEnd = '1'
          this.$message({
            offset: 100,
            message: '请输入重量范围!',
            type: 'warning'
          })
          return
        } else if (scope.capacityTextEnd !== '0') {
          try {
            validateNumber(scope.capacityTextEnd)
          } catch (e) {
            this.$message({
              showClose: true,
              message: e.message,
              type: 'error'
            })
            scope.capacityTextStart = '1'
            scope.capacityTextEnd = '1'
            return
          }
        }
        const capacity = scope.capacityTextStart + '-' + scope.capacityTextEnd
        // 触发watch
        scope.capacityText = capacity
        this.isBtn=true
      },
      weightChange(scope, data, label) {
        scope[data.key[1]] = ''
        scope[data.key[2]] = ''
        scope.capacityText = label
                this.isBtn=true
        console.log("weightChange:"+weightChange)
      }
    }
  }
</script>

<style scoped lang='scss'>
  .source-news {
    font-family: MicrosoftYaHei;
    margin-bottom: 1rem;
  }

  /deep/ .main-wrap {
    margin-top: 1rem;

    .main {
      width: 1200px;
      margin: 0 auto 1rem;
      border: 1px solid rgba(229, 229, 229, 1);
      box-sizing: border-box;

      .el-form-item {
        padding-left: 20px;
        padding-right: 20px;

        .el-form-item__label {
          width: 5.25rem !important;
        }

        .el-tag {
          margin-right: 1rem;
        }
      }

      .el-form {
        .selected-conditions {
          background-color: #f6f6f6;

          .el-form-item__content {
            display: flex;
            flex-wrap: wrap;

            .el-tag {
              margin-top: auto;
              margin-bottom: auto;
            }
          }

          .clear-conditions {
            cursor: pointer;
            color: #999999;
            align-items: flex-end;
            display: block;
            margin-left: auto;
          }
        }

        .capacity-content {
          .el-form-item__content {
            display: flex;
          }

          .el-input {
            margin-right: 1rem;
            width: 80px;
          }

          .des {
            margin-right: 1rem;
          }

          .el-button-ml {
            background-color: #be2316;
            color: #ffffff;
          }
        }

        /*复选组样式 start*/
        .el-checkbox-button {
          margin-right: 1rem;
        }

        .el-checkbox-button:first-child .el-checkbox-button__inner {
          border-radius: 0 !important;
        }

        .el-checkbox-button:last-child .el-checkbox-button__inner {
          border-radius: 0 !important;
        }

        .el-checkbox-button.is-checked .el-checkbox-button__inner {
          background-color: #be2316;
          border-color: #be2316;
          color: #ffffff;
          box-shadow: -1px 0 0 0 #be2316;
        }

        .el-checkbox-button__inner:hover {
          color: #be2316;
        }

        .el-checkbox-button .el-checkbox-button__inner {
          border: none !important;
        }

        .el-checkbox-button.is-checked:first-child .el-checkbox-button__inner {
          border-left-color: #be2316;
        }

        /*复选组样式 end*/
        /*单选组样式 start*/
        .el-radio-button {
          margin-right: 1rem;
        }

        .el-radio-button:first-child .el-radio-button__inner {
          border-radius: 0 !important;
        }

        .el-radio-button:last-child .el-radio-button__inner {
          border-radius: 0 !important;
        }

        .el-radio-button__orig-radio:checked+.el-radio-button__inner {
          background-color: #be2316;
          border-color: #be2316;
          color: #ffffff;
          box-shadow: -1px 0 0 0 #be2316;
        }

        .el-radio-button__inner:hover {
          color: #be2316;
        }

        .el-radio-button .el-radio-button__inner {
          border: none !important;
        }

        .el-radio-button.is-checked:first-child .el-radio-button__inner {
          border-left-color: #be2316;
        }

        /*单选组样式 end*/
        .transport-data {
          display: flex;

          .el-input {
            margin-right: 1rem;
          }

          .des {
            margin-right: 1rem;
          }
        }

        .form-item {
          margin-right: 0;

          .form-item-btn {
            background: #be2316;
            border: none;

            i {
              font-size: 14px;
              padding-right: 10px;
            }
          }
        }
      }
    }

    .content {
      position: relative;
      width: 1200px;
      margin: 0 auto;
      margin-bottom: 50px;

      .content-img {
        width: 1200px;
      }

      .content-shoucang-tc {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -85px;
        margin-top: -35px;
      }

      .content-baojia {
        position: absolute;
        width: 50px;
        height: 100%;
        right: 0;
        top: 0;
      }

      .content-shoucang {
        position: absolute;
        width: 50px;
        height: 100%;
        right: 50px;
        top: 0;
      }
    }

    /*表格相关*/
    .table-wrap {
      width: 1200px;
      margin: 0 auto;
    }
  }

  /deep/ .el-form.quotation-form {
    display: flex;
    flex-direction: column;

    .form-line {
      display: flex;
      flex-direction: row;
      margin: auto;

      .quotation-label {
        line-height: 40px;
      }

      .quotation-form-btn {
        background-color: #a7a7a7 !important;
        color: white;
        border-radius: 15px;
        width: 100px;
      }

      .quotation-btn {
        background-color: #be2316 !important;
        margin-right: 2rem;
      }
    }

    .el-input {
      width: 90%;
      margin-right: 0.5rem;
      font-size: 24px;

      .el-input__inner {
        text-align: center;
        color: #ff0000 !important;
      }
    }
  }
</style>
